import { z } from 'zod';
/**
 * Artifact Schema
 * Represents an artifact (document, file, template, etc.) in the organization
 */ export const ArtifactSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    type: z.string().optional(),
    fileUrl: z.string().optional(),
    size: z.number().optional(),
    mimeType: z.string().optional(),
    createdBy: z.string().optional(),
    createdByName: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    deletedAt: z.number().optional()
});

//# sourceMappingURL=artifact.schema.js.map